export const ADMIN_PASSWORD_HELP = 'Almeno 12 caratteri, una maiuscola, un numero e un carattere speciale.';

export function getAdminPasswordError(password) {
  if (password.length < 12) {
    return `La nuova password è troppo corta: servono almeno 12 caratteri (ne hai ${password.length}).`;
  }
  if (password.length > 128) {
    return 'La nuova password deve avere al massimo 128 caratteri.';
  }
  if (!/[A-Z]/.test(password) || !/[0-9]/.test(password) || !/[^A-Za-z0-9\s]/.test(password)) {
    return 'La nuova password deve contenere almeno una maiuscola, un numero e un carattere speciale.';
  }
  return null;
}
